// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.X1WSdEBMQkYNn6cS4xK0{flex-direction:column;gap:32px;min-height:352px;display:flex}.PC8EgaZhP144Ce2wvYxi{flex-direction:column;gap:12px;padding-top:8px;display:flex}.aGPpkhb3EPE3iN9dVpwo{flex-direction:column;gap:4px;display:flex}.tk08j9VW_cOKJ42Y52Jn{grid-template-columns:160px auto;align-items:flex-start;display:grid}.tk08j9VW_cOKJ42Y52Jn .yLuC0_JDQk2ukerehlir{min-height:32px;color:var(--content-primary-tertiary);align-items:center;display:flex}.tk08j9VW_cOKJ42Y52Jn .imBHTozQ8Rms1V7dlxzA{align-items:center;gap:8px;min-height:32px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `X1WSdEBMQkYNn6cS4xK0`,
	"header": `PC8EgaZhP144Ce2wvYxi`,
	"details": `aGPpkhb3EPE3iN9dVpwo`,
	"grid": `tk08j9VW_cOKJ42Y52Jn`,
	"label": `yLuC0_JDQk2ukerehlir`,
	"value": `imBHTozQ8Rms1V7dlxzA`
};
export default ___CSS_LOADER_EXPORT___;
